export default __webpack_public_path__ + "static/media/python-original.c4b1b05e.svg";